module.exports = __webpack_public_path__ + "img/starempty.d8081b87.svg";